import React, { useState, useEffect } from 'react';
import './UserView.css';
import Labels from './Labels.json';
import { useParams } from "react-router-dom";
import VDIComplianceForm from "../../components/VDICompliance/VDIComplianceForm";
import { useSelector } from "react-redux";
import {getVDIRepoStatus, saveVDICompliance, getVDIComplianceDate } from '../../services/Service';
import { fetchEmployeeData, showErrorNotification, showNotification } from '../../util/documentConfig';

function DisplayVDICompliance({ onCompletion }) {
    //const [isChecked, setIsChecked] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userId, setUserId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const [isVDICompleted, setIsVDICompleted] = useState(false); // for direct update of date for normal user
    const [vdiComplianceDate, setVdiComplianceDate] = useState(null); // ✅ Fix: Set default as null

    const { id } = useParams();
    const email = localStorage.getItem("userEmail");
    const token = useSelector((state) => state.auth.token);

    // ✅ Determine user role (Admin or Normal User)
    useEffect(() => {
        const roleUser = JSON.parse(localStorage.getItem("userRoles"));
        if (roleUser && roleUser.includes("ADMINUSER")) {
            setIsAdmin(true);
        }
        if (!id) {
            fetchData();
        } else {
            setUserId(id);
        }
    }, [id]);

    // ✅ Fetch VDI Compliance Date when `userId` is set
    useEffect(() => {
        if (userId) {
            handleGetStatus();
            fetchVDIComplianceDate();
        }
    }, [userId]);

    // ✅ Fetch User ID
    const fetchData = async () => {
        try {
            const fetchedUserId = await fetchEmployeeData(email);
            setUserId(fetchedUserId);
        } catch (error) {
            showErrorNotification("Failed to fetch userId");
        }
    };

    // ✅ Fetch VDI Compliance Status
    const handleGetStatus = async () => {
 
        const response = await getVDIRepoStatus(userId);
       // alert(response.status);
        //console.log('Response:****' , response);
        const newStatus = !isVDICompleted;
        setIsVDICompleted(newStatus);
 
        onCompletion(newStatus); // Notify parent component
 
        //const savedStatus = localStorage.getItem(`vdi_${userId}`)
        //alert(savedStatus);
        if (response.ok && response.status!=404) {
            //alert(response.data);
 
            setIsVDICompleted(true);
            onCompletion(true);
            localStorage.setItem(`vdi_${userId}`, newStatus); // Save to localStorage
            // localStorage.setItem(`skillRepo_${userId}`, "Completed"); // Save to localStorage
            //alert("Status retrieved successfully");
        } else {
 
            setIsVDICompleted(false);
            onCompletion(false);
            //alert(`Failed to retrieve status: ${response.data}`);
        }
    };

    // Fetch compliance date immediately after submission
    const onVDIComplianceCreate = async () => {
        try {
            const response = await saveVDICompliance(userId);
            if (response.ok) {
                showNotification("VDI Compliance added successfully!");
                
                // ✅ Fetch compliance date immediately after submission
                await fetchVDIComplianceDate();
    
                // ✅ Ensure the tab updates instantly
                setIsVDICompleted(true);
                handleGetStatus(); 
                return response;
            } else {
                throw new Error("Failed to save VDI Compliance.");
            }
        } catch (error) {
            showErrorNotification("Failed to add VDI Compliance");
        }
    };

    // ✅ Fetch VDI Compliance Date
    const fetchVDIComplianceDate = async () => {
        try {
            let response = await getVDIComplianceDate(userId);

            if (response && response.data && typeof response.data === "string") {
                setVdiComplianceDate(response.data);
            } else {
                setVdiComplianceDate(null); // ✅ Fix: Keep it null if no date
            }
        } catch (error) {
            console.error("Error fetching VDI compliance date:", error);
            setVdiComplianceDate(null);
        }
    };

    // ✅ Handle Modal Actions
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <div className="bordered-div userview_container">
            <h2 className="custom-h2">{Labels.VDICompliance_Title}</h2>
            <p>
                {Labels.VDICompliance_Description}
                <br /><br />
                <strong>Note:</strong> {Labels.VDICompliance_Contact_Info}
                <a href={`mailto:${Labels.VDICompliance_Email}`}>{Labels.VDICompliance_Email}</a>.
                <br /><br />
            </p>

            {/* ✅ If VDI Compliance is completed, show the completion date */}
            {vdiComplianceDate && isVDICompleted ? (
                <h4>✅ VDI Compliance Completed on: {vdiComplianceDate}</h4>
            ) : (
                <>
                    {/* 🔹 If Admin is checking a normal user, show missing compliance message */}
                    {isAdmin ? (
                      <h4 style={{ color: "red"}}>
                             VDI Compliance not completed 
                        </h4>
                    ) : (
                        <>
                            {/* 🔹 If a normal user is viewing their own status, show Review Link */}
                            <h4>
                                <strong>{Labels.VDICompliance_Walmart_Link_Label}</strong>
                                <a href="#" onClick={openModal}>
                                    {Labels.VDICompliance_Walmart_Link_Text}
                                </a>
                            </h4>

                            {/* Open the VDI Compliance form when clicked */}
                            {isModalOpen && (
                             <VDIComplianceForm
                                isOpen={isModalOpen}
                                onClose={closeModal}
                                onVDIComplianceCreate={onVDIComplianceCreate} // ✅ Ensure this is passed
                            />
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default DisplayVDICompliance;
